var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuIcnProducts = function SvgMenuIcnProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 8.1v-.4c0-.1 0-.1-.1-.2l-.1-.1-.1-.1c-.1 0-.1-.1-.2-.2l-7.6-4.4c-.3-.2-.7-.2-1.1 0L4.1 6.8c-.2.1-.3.3-.4.4 0 .1-.1.1-.1.2V16c0 .4.2.7.5.9l7.6 4.4c.1 0 .2.1.3.1h.3c.2 0 .4-.1.5-.1l7.1-4.1c.3-.2.5-.6.5-.9V8.1zm-8.7-3.2 5.5 3.2-4.9 2.9-5.5-3.2 4.9-2.9zm-6 4.7 5.4 3.2v5.7l-5.4-3.2V9.6zm7.6 8.9v-5.7l3.7-2.1 1.3-.7v5.7l-5 2.8z"
  })));
};
export default SvgMenuIcnProducts;